import React, {useMemo} from 'react';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import {useSelector} from 'react-redux';

import HorizontalGroup from './HorizontalGroup';
import HorizontalCollapse from './HorizontalCollapse';
import HorizontalItem from './HorizontalItem';

// ✅ correct aliases
// import routesConfig from '@crema/routes/routesConfig';
import {filterNavByAccess} from '@crema/utility/hooks/filterNavByAccess';
import {checkPermission} from '@crema/utility/helper/RouteHelper';
import {useAbility} from '@crema/utility/hooks';

// If you don't use aliases, swap to your relative imports:
import routesConfig from '../../../../../pages/routesConfig';
// import {useAbility} from '../../../../hooks/useAbility';
// import {filterNavByAccess} from '../../../../utility/filterNavByAccess';
// import {checkPermission} from '../../../../utility/helper/RouteHelper';

const HorizontalNav = () => {
  const ability = useAbility();
  const {user} = useSelector(({user}) => user) || {};

  // 1) feature/permission filter
  const abilityFiltered = useMemo(
    () => filterNavByAccess(routesConfig, ability),
    [ability],
  );

  // 2) optional role filter (only when a node has `auth`)
  const finalFiltered = useMemo(() => {
    const applyRoleGate = (nodes) =>
      (Array.isArray(nodes) ? nodes : [])
        .map((n) => {
          const roleOK = !n?.auth || checkPermission(n.auth, user?.role);
          if (!roleOK) return null;

          if (Array.isArray(n.children) && n.children.length) {
            const kids = applyRoleGate(n.children);
            if (
              (n.type === 'group' || n.type === 'collapse') &&
              kids.length === 0
            )
              return null;
            return {...n, children: kids};
          }
          return n;
        })
        .filter(Boolean);

    return applyRoleGate(abilityFiltered);
  }, [abilityFiltered, user?.role]);

  if (!finalFiltered.length) return null;

  return (
    <List className='navbarNav'>
      {finalFiltered.map((item) => (
        <React.Fragment key={item.id}>
          {item.type === 'group' && (
            <HorizontalGroup item={item} nestedLevel={0} />
          )}
          {item.type === 'collapse' && (
            <HorizontalCollapse item={item} nestedLevel={0} />
          )}
          {item.type === 'item' && (
            <HorizontalItem item={item} nestedLevel={0} />
          )}
          {item.type === 'divider' && <Divider sx={{my: 5}} />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default HorizontalNav;
